// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"TooltipStyle_tooltipContainer__y359+","arrow":"TooltipStyle_arrow__a9Kte"};